(() => {
  const durations = ['3-hours', '1-day', '2-days', '3-days', '4-days', '5-days', '7-days'];
  const interests = ['hutongs', 'culture', 'wall', 'food', 'family', 'views', 'art', 'night', 'gardens'];
  const styles = ['relaxed', 'culture', 'family', 'food', 'views', 'hutongs'];
  const normalise = input => ({
    duration: durations.includes(input?.duration) ? input.duration : '1-day',
    interests: [...new Set((Array.isArray(input?.interests) ? input.interests : []).filter(value => interests.includes(value)))],
    styles: [...new Set((Array.isArray(input?.styles) ? input.styles : []).filter(value => styles.includes(value)))],
    party: ['1-2', '3-5', '6+'].includes(input?.party) ? input.party : '1-2',
    group: ['adults', 'children', 'mixed'].includes(input?.group) ? input.group : 'adults',
    walking: ['standard', 'gentle'].includes(input?.walking) ? input.walking : 'standard',
    budget: String(input?.budget || '').slice(0, 120),
    date: /^\d{4}-\d{2}-\d{2}$/.test(input?.date || '') ? input.date : ''
  });
  const rank = (routes, input) => {
    const profile = normalise(input);
    const wanted = [...new Set([...profile.interests, ...profile.styles.filter(value => interests.includes(value))])];
    const ranked = routes.filter(route => route.duration === profile.duration).map((route, order) => {
      const tags = route.tags || [];
      const match = wanted.filter(tag => tags.includes(tag));
      const wall = tags.includes('wall') || /mutianyu|jinshanling|simatai|great wall/i.test(route.title + ' ' + route.places);
      const mountain = /jinshanling|simatai/i.test(route.title + ' ' + route.places);
      const overnight = /jinshanling|gubei/i.test(route.places) && ['5-days', '7-days'].includes(route.duration) && tags.includes('views');
      const family = tags.includes('family');
      const score = match.length * 10 + (profile.group !== 'adults' && family ? 14 : 0) +
        (profile.styles.includes('relaxed') && (tags.includes('gardens') || tags.includes('hutongs')) ? 3 : 0);
      return { ...route, match, wall, mountain, overnight, family, score, order };
    }).filter(route => profile.walking !== 'gentle' || !route.wall)
      .sort((a, b) => b.score - a.score || a.order - b.order);
    const matching = wanted.length ? ranked.filter(route => route.match.length) : ranked;
    return { profile, wanted, exact: !wanted.length || matching.length > 0, results: (matching.length ? matching : ranked).slice(0, 3) };
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { normalise, rank, durations };
  if (typeof document === 'undefined') return;
  const root = document.querySelector('#build-your-beijing');
  const dialog = document.querySelector('#jb-builder-dialog');
  const labelNode = document.querySelector('#jb-builder-labels');
  if (!root || !dialog || !labelNode) return;
  const labels = Object.fromEntries(Object.entries(JSON.parse(labelNode.textContent)).map(([key, value]) => [key, new DOMParser().parseFromString(value, 'text/html').body.textContent]));
  const storageKey = 'jb-builder-preferences-v1';
  const durationButtons = [...root.querySelectorAll('.time-step button')];
  const interestButtons = [...root.querySelectorAll('.interest-grid button')];
  const styleButtons = [...root.querySelectorAll('.style-step button')];
  const output = dialog.querySelector('[data-builder-results]');
  const status = dialog.querySelector('[data-builder-status]');
  const form = dialog.querySelector('form');
  const cache = new Map();
  let sequence = 0;
  let controller;
  let profile;
  try { profile = normalise(JSON.parse(sessionStorage.getItem(storageKey) || '{}')); } catch { profile = normalise({}); }
  const params = new URLSearchParams(location.search);
  const dayDuration = { 1: '1-day', 2: '2-days', 3: '3-days', 4: '4-days', 5: '5-days', 7: '7-days' };
  if (durations.includes(params.get('trip_duration'))) profile.duration = params.get('trip_duration');
  else if (dayDuration[params.get('trip_days')]) profile.duration = dayDuration[params.get('trip_days')];
  const applyButtons = (buttons, values, selected) => buttons.forEach((button, index) => {
    button.dataset.builderValue = values[index];
    button.classList.toggle('selected', selected.includes(values[index]));
    button.setAttribute('aria-pressed', String(selected.includes(values[index])));
  });
  applyButtons(durationButtons, durations, [profile.duration]);
  applyButtons(interestButtons, interests, profile.interests);
  applyButtons(styleButtons, styles, profile.styles);
  ['party', 'group', 'walking', 'budget', 'date'].forEach(key => { form.elements[key].value = profile[key]; });
  const save = () => { try { sessionStorage.setItem(storageKey, JSON.stringify(profile)); } catch {} };
  const selected = buttons => buttons.filter(button => button.classList.contains('selected')).map(button => button.dataset.builderValue);
  const read = () => {
    profile = normalise({ ...profile, duration: selected(durationButtons)[0], interests: selected(interestButtons), styles: selected(styleButtons), ...Object.fromEntries(['party', 'group', 'walking', 'budget', 'date'].map(key => [key, form.elements[key].value])) });
    [...durationButtons, ...interestButtons, ...styleButtons].forEach(button => button.setAttribute('aria-pressed', String(button.classList.contains('selected'))));
    save();
    return profile;
  };
  [...durationButtons, ...interestButtons, ...styleButtons].forEach(button => button.addEventListener('click', read));
  const safeUrl = value => {
    try { const url = new URL(value, location.origin); return url.origin === location.origin && url.pathname.startsWith('/pages/') ? url : null; } catch { return null; }
  };
  const extract = (scope, duration) => [...scope.querySelectorAll('.jb-catalog-card[data-duration]')].filter(card => card.dataset.duration === duration).flatMap(card => {
    const url = safeUrl(card.getAttribute('href'));
    const title = card.querySelector('h3')?.textContent.trim();
    if (!url || !title) return [];
    const image = card.querySelector('img');
    const video = card.querySelector('video');
    return [{ title, duration, tags: (card.dataset.interests || '').split(/\s+/).filter(Boolean), places: card.querySelector('p')?.textContent.trim() || '', url: url.href, image: image?.getAttribute('src') || video?.getAttribute('poster') || '', alt: image?.getAttribute('alt') || title }];
  });
  const fetchRoutes = async (duration, signal) => {
    if (cache.has(duration)) return cache.get(duration);
    let routes = extract(document, duration);
    if (!routes.length) {
      const handle = duration === '1-day' ? '1-day-in-beijing' : duration + '-in-beijing';
      const url = new URL('/pages/' + handle, location.origin);
      if (params.has('preview_theme_id')) url.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
      const response = await fetch(url, { credentials: 'same-origin', signal });
      if (!response.ok) throw new Error('catalog_unavailable');
      routes = extract(new DOMParser().parseFromString(await response.text(), 'text/html'), duration);
    }
    if (!routes.length) throw new Error('catalog_empty');
    const unique = [...new Map(routes.map(route => [route.url, route])).values()];
    cache.set(duration, unique);
    return unique;
  };
  const node = (tag, text, className) => { const element = document.createElement(tag); if (text) element.textContent = text; if (className) element.className = className; return element; };
  const render = data => {
    output.replaceChildren();
    status.textContent = !data.results.length ? labels.empty : !data.exact ? labels.alternatives : labels.ready;
    dialog.querySelector('[data-builder-summary]').textContent = [labels[data.profile.duration], ...data.profile.interests.map(tag => labels[tag]), labels[data.profile.group], labels[data.profile.walking]].join(' · ');
    data.results.forEach(route => {
      const card = node('article', '', 'jb-builder-card');
      if (route.image) { const image = node('img'); image.src = route.image; image.alt = route.alt; image.loading = 'lazy'; image.width = 800; image.height = 500; card.append(image); }
      card.append(node('small', labels[route.duration]), node('h3', route.title), node('p', route.places));
      const reasons = route.match.length ? [labels.matches + ' ' + route.match.map(tag => labels[tag]).join(', ')] : [labels.duration_match];
      if (data.profile.group !== 'adults' && route.family) reasons.push(labels.family_reason);
      if (data.profile.group !== 'adults' && !route.family) reasons.push(labels.children_check);
      if (data.profile.walking === 'gentle') reasons.push(labels.walking_check);
      if (route.wall) reasons.push(labels.wall_check);
      if (route.overnight) reasons.push(labels.overnight_check);
      const list = node('ul'); reasons.forEach(reason => list.append(node('li', reason))); card.append(list);
      const link = node('a', labels.view, 'jb-builder-route');
      const url = safeUrl(route.url);
      url.searchParams.set('return_to', location.pathname + '?chapter=build-your-beijing&trip_days=' + (data.profile.duration === '3-hours' ? '' : data.profile.duration.split('-')[0]) + '&trip_duration=' + data.profile.duration);
      if (params.has('preview_theme_id')) url.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
      link.href = url.href; card.append(link); output.append(card);
    });
    const lines = [labels.enquiry_intro, labels[data.profile.duration], labels.preferences + ': ' + (data.wanted.map(tag => labels[tag]).join(', ') || labels.open_interests), labels.party + ': ' + data.profile.party, labels[data.profile.group], labels[data.profile.walking], ...data.results.map(route => route.title + '\n' + route.url)];
    if (data.profile.date) lines.push(labels.date + ': ' + data.profile.date);
    if (data.profile.budget) lines.push(labels.budget + ': ' + data.profile.budget);
    lines.push(labels.quote_note);
    dialog.querySelectorAll('[data-builder-whatsapp]').forEach(link => { link.href = 'https://wa.me/' + link.dataset.builderWhatsapp + '?text=' + encodeURIComponent(lines.join('\n')); });
  };
  const recommend = async () => {
    const current = ++sequence;
    controller?.abort(); controller = new AbortController();
    const selection = read(); output.replaceChildren();
    dialog.querySelector('[data-builder-summary]').textContent = labels[selection.duration];
    dialog.querySelectorAll('[data-builder-whatsapp]').forEach(link => link.removeAttribute('href'));
    status.textContent = labels.loading; output.setAttribute('aria-busy', 'true');
    try { const routes = await fetchRoutes(selection.duration, controller.signal); if (current === sequence) render(rank(routes, selection)); }
    catch (error) { if (current === sequence && error.name !== 'AbortError') status.textContent = labels.error; }
    finally { if (current === sequence) output.setAttribute('aria-busy', 'false'); }
  };
  root.querySelector('.show-journey').addEventListener('click', () => { dialog.showModal(); recommend(); });
  dialog.querySelector('[data-builder-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { ++sequence; controller?.abort(); });
  form.addEventListener('submit', event => { event.preventDefault(); recommend(); });
  form.addEventListener('change', recommend);
})();
